<template>
  <div>
    <span>
      <b-button size="sm" variant="outline-light" v-on:click="stokEkstre()"
        ><Icon
          icon="material-symbols:search-rounded"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="'Öncelikli olarak işaretle'"
          color="#7367F0"
      /></b-button>
    </span>
    <StokEkstre ref="ekstre" />
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import StokEkstre from "../stok-components/StokEkstre.vue";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import moment from "moment";
import { VBTooltip } from "bootstrap-vue";
export default {
  directives: {
    "b-tooltip": VBTooltip
  },
  components: {
    Icon,
    StokEkstre
  },
  methods: {
    stokEkstre() {
      console.log(this.params.data);
      this.$store.commit(
        "account/STOKSTOCKNAME_TUT",
        this.params.data.STOCKNAME
      );
      this.$store.commit("account/STOKID_TUT", this.params.data.STOCKID);
      this.$store.commit("account/STOKSTOCKNO_TUT", this.params.data.STOCKNO);
      this.$refs.ekstre.stokEkstreDetay();
    },
    alimSec() {
      console.log(this.params.data);
      var formattoday = new Date();
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (typeof this.params.data.miktar == "undefined") {
        this.params.data.miktar = 0;
      }
      if (typeof this.params.data.fiyat == "undefined") {
        this.params.data.fiyat = 0;
      }
      if (typeof this.params.data.IND1 == "undefined") {
        this.params.data.IND1 = 0;
      }
      if (typeof this.params.data.IND2 == "undefined") {
        this.params.data.IND2 = 0;
      }
      if (typeof this.params.data.IND3 == "undefined") {
        this.params.data.IND3 = 0;
      }
      const args = {
        token: Store.state.tokenId,
        STOCKID: this.params.data.STOCKID,
        TRANSDATE: "2022-06-06", // moment(String(formattoday)).format("YYYY-DD-MM"),
        TALEPTARIHI: "2022-06-06", //moment(String(formattoday)).format("YYYY-DD-MM"),
        EMPLOYEEID: Store.state.UserId,
        ADET: this.params.data.miktar,
        FIYAT: this.params.data.fiyat,
        TUTAR: this.params.data.miktar * this.params.data.fiyat,
        ACTID: Store.state.account.planlamaCariId, //Store.state.account.satinalmaPlanlamaACTID,
        ACIKLAMA: "",
        STATUS: "2",
        IND1: this.params.data.IND1,
        IND2: this.params.data.IND2,
        IND3: this.params.data.IND3
      };
      console.log(args);
      soap.createClient(url, function(err, client) {
        client.INT_Sal_SatinalmaTalepEkle(args, function(err, result) {
          if (result.INT_Sal_SatinalmaTalepEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          console.log(result);
          try {
            vm.veriler = JSON.parse(result.INT_Sal_SatinalmaTalepEkleResult);
            vs.notify({
              title: "Talep",
              text: "Eklendi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
          } catch (error) {
            vs.notify({
              title: "Talep",
              text: "Talep Eklenirken Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  }
};
</script>
